// A waveform's broadband_features may be null (no stored values, or velocity in
// demod mode) or lack a key (demod has no p2p): only a finite number is shown.
export const hasBroadbandFeature = (features, key) => (
  !!features && typeof features[key] === 'number' && Number.isFinite(features[key])
);
